var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { combineSxProps } from "../../Utils";
const containerSxProps = {
    width: "100%",
    height: "100%",
    backgroundColor: "other.editorBackground",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px",
    gap: "16px"
};
const contentWrapperSxProps = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap"
};
export const UploadFile = (props) => {
    const { primaryText, secondaryText, actions, sx } = props, boxProps = __rest(props, ["primaryText", "secondaryText", "actions", "sx"]);
    return (_jsxs(Box, Object.assign({ sx: combineSxProps(containerSxProps, sx) }, boxProps, { children: [_jsx(Typography, { variant: "subtitle1", color: "text.primary", align: "center", children: primaryText }), _jsx(Box, { sx: contentWrapperSxProps, children: actions }), _jsx(Typography, { variant: "caption", color: "text.secondary", align: "center", children: secondaryText })] })));
};
//# sourceMappingURL=UploadFile.js.map